import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {watchAds} from "../../../advertisement/actions";

export default function watchAdsHandler({ payload }: ActionType<typeof watchAds>): IAnalyticsAction | undefined {
    return {
        category: "ad",
        object: payload.adType === 'rewarded' ? "reward" : "force",
        name: "click",
        addition: payload.reward
    };
}